import { defineMessages } from 'react-intl';

const messages = defineMessages({
  serviceUnavailable: {
    id: 'collegeevents.filters.create.error.serviceUnavailable',
    defaultMessage: 'The service is not available at this time.',
  },
  incorrectPostalCode: {
    id: 'collegeevents.filters.create.error.incorrectPostalCode',
    defaultMessage: 'Postal code is not a valid US postal code.',
  },
  errorUniqueName: {
    id: 'collegeevents.filters.create.error.uniqueName',
    defaultMessage: 'Filter name should be unique.',
  },
  gender: {
    id: 'collegeevents.filters.create.gender',
    defaultMessage: 'Gender',
  },
  location: {
    id: 'collegeevents.filters.create.location',
    defaultMessage: 'Location',
  },
  within: {
    id: 'collegeevents.filters.create.within',
    defaultMessage: 'Within',
  },
  miles: {
    id: 'collegeevents.filters.create.miles',
    defaultMessage: '{value} miles',
  },
  outsideOf: {
    id: 'collegeevents.filters.create.outside-of',
    defaultMessage: 'outside of',
  },
  postalCode: {
    id: 'collegeevents.filters.create.postal-code',
    defaultMessage: 'Postal Code',
  },
  displaymiles: {
    id: 'collegeevents.filters.create.display-miles',
    defaultMessage: 'miles',
  },
  ethnicity: {
    id: 'collegeevents.filters.create.ethnicity',
    defaultMessage: 'Race and Ethnicity',
  },
  gradeLevel: {
    id: 'collegeevents.filters.create.grade-level',
    defaultMessage: 'Grade Level',
  },
  letterGrade: {
    id: 'collegeevents.filters.create.letter-grade',
    defaultMessage: 'GPA',
  },
  preview: {
    id: 'collegeevents.filters.create.preview',
    defaultMessage: 'Filter Summary',
  },
  previewMsg: {
    id: 'collegeevents.filters.create.preview-msg',
    defaultMessage: 'As you build your filter, a summary of your selection will display here.',
  },
  name: {
    id: 'collegeevents.filters.create.name',
    defaultMessage: 'Filter Name',
  },
  save: {
    id: 'collegeevents.filters.create.save',
    defaultMessage: 'Save Filter',
  },
  cancel: {
    id: 'collegeevents.filters.create.cancel',
    defaultMessage: 'Cancel',
  },
  cancelTitle: {
    id: 'collegeevents.filter.cancel.title',
    defaultMessage: 'Are you sure you want to cancel?',
  },
  cancelSubtitle: {
    id: 'collegeevents.filter.cancel.subtitle',
    defaultMessage: "Any changes you've made to this filter will not be saved.",
  },
  cancelConfirmButton: {
    id: 'collegeevents.filter.cancel.confirm.button',
    defaultMessage: "Don't Save",
  },
  cancelRejectButton: {
    id: 'collegeevents.filter.cancel.reject.button',
    defaultMessage: 'Continue Editing',
  },
  missingPostalCode: {
    id: 'collegeevents.filters.create.missingPostalCode',
    defaultMessage: 'Postal Code is required',
  },
  missingLocation: {
    id: 'collegeevents.filters.create.missingLocation',
    defaultMessage: 'Location is required',
  },
  missingLocationandPostalCode: {
    id: 'collegeevents.filters.create.missingLocationandPostalCode',
    defaultMessage: 'Location and Postal Code are required',
  },
  missingFilterName: {
    id: 'collegeevents.filters.create.missingFilterName',
    defaultMessage: 'Filter Name is required',
  },
  badPostalCode: {
    id: 'collegeevents.filters.create.badPostalCode',
    defaultMessage: 'Please enter a valid US postal code',
  },
});

export default messages;
